<template>
	<div id="organizador-eventos-page">
		<div class="eventos-top">
			<div class="slider-eventos">
				<vueper-slides ref="eventosSlider"
					:visibleSlides="4"
					:breakpoints="{ 1600: { visibleSlides: 3 }, 1200: { visibleSlides: 2 }, 900: { visibleSlides: 1 } }"
					:arrows="false"
					:bullets="false"
					:gap="1"
					:slide-multiple="true"
					:infinite="false"
					:touchable="false"
					fixed-height="106px"
					style="margin-bottom: 0px;"
					class="no-shadow"
				>
					<vueper-slide v-for="(eve) in SDTEventos" :key="eve.EventoId">
						<template #content>
							<div class="evento" @click.prevent="setEventoActivo(eve.EventoId)" :class="Number(eve.EventoId) === Number(EventoActivo) ? 'eve-selected' : eve.EventoEstado === 'A' ? 'eve-act' : eve.EventoEstado === 'I' ? 'eve-ing' : eve.EventoEstado === 'F' ? 'eve-fin' : ''">
								<div class="evento-top">
									<i class='bx bx-star' v-if="eve.EventoDestacado && eve.EventoEstado === 'A'" content="Evento destacado" v-tippy="{ placement : 'left', arrow: true}"></i>
									<i class='bx bx-world' v-if="eve.EventoPublicado && eve.EventoEstado === 'A'" content="Evento publicado en web" v-tippy="{ placement : 'left', arrow: true}"></i>
									<div class="evento-estado" :style="{ 'background-color': eve.EventoEstadoColor }" >
										{{ eve.EventoEstadoTxt }}
									</div>
								</div>
								<div class="evento-left">
									<div class="evento-row">
										<div class="evento-instituciones" v-if="eve.EventoTipoRequiereInstitucion">
											<div class="institucion" :data-tooltip="eve.InstitucionLocalNombre">
												<img :src="eve.InstitucionLocalEscudoURL" :alt="eve.InstitucionLocalNombre">
											</div>
											<div class="institucion" :data-tooltip="eve.InstitucionVisitanteNombre">
												<img :src="eve.InstitucionVisitanteEscudoURL" :alt="eve.InstitucionVisitanteNombre">
											</div>
										</div>
										<div class="evento-info">
											<span class="evento-tipo">Fútbol 1ra división</span>
											<span class="evento-nombre" v-if="!eve.EventoTipoRequiereInstitucion">{{ eve.EventoNombre }}</span>
											<span class="evento-nombre" v-else>{{ eve.InstitucionLocalNombre }} vs. {{ eve.InstitucionVisitanteNombre }}</span>
											<span class="evento-competencia" v-if="eve.EventoTipoRequiereCompetencia">{{ eve.CompetenciaNombre }}</span>
										</div>
									</div>
								</div>
								<div class="evento-right">
									<div class="evento-fecha">
										<span class="fecha-dia">{{ eve.EventoFechaDiaSemana }}</span>
										<span class="fecha-nro">{{ eve.EventoFechaNumero }}</span>
										<span class="fecha-mes">{{ eve.EventoFechaMes }}</span>
									</div>
								</div>
							</div>
						</template>
					</vueper-slide>
				</vueper-slides>
			</div>
			<div class="slider-arrows">
				<div class="eve-arrow eve-arrow-previous" @click="$refs.eventosSlider.previous()">
					<img src="../../assets/arrow-right.svg">
				</div>
				<div class="eve-arrow eve-arrow-next" @click="$refs.eventosSlider.next()">
					<img src="../../assets/arrow-right.svg">
				</div>
			</div>
		</div>
		<div class="eventos-content" v-if="EventoActivo > 0">
			<router-view name="organizadoreventos" :key="1"></router-view>
		</div>
		<div class="eventos-content" v-else>
			<div class="dashboard-grid">
				<div class="dashboard-card">
					<span class="card-value">{{ CantEventos }}</span>
					<span class="card-label">Eventos organizados en LineUp Tickets</span>
				</div>
				<div class="dashboard-card">
					<span class="card-value">{{ CantTickets }}</span>
					<span class="card-label">Entradas vendidas</span>
				</div>
				<!-- <div class="dashboard-card">
					<span class="card-value"><i class='bx bx-user-circle'></i></span>
					<span class="card-label">Gestionar los usuarios de mi organización</span>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapGetters }  from 'vuex';
	import { VueperSlides, VueperSlide } from 'vueperslides'
	import 'vueperslides/dist/vueperslides.css'

	export default {
		data(){
			return{
				EventoActivo: 0,
				SDTEventos: null,
				CantEventos: 0,
				CantTickets: 0
			}
		},
		components: {
			VueperSlides,
			VueperSlide
		},
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),
		},
		async mounted(){
			this.$store.dispatch('cargando', true);

			if(this.$route.params.eventoId && Number(this.$route.params.eventoId) > 0){
				this.EventoActivo = Number(this.$route.params.eventoId)
			}

			await this.getEventos();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			async setEventoActivo(id){
				if(Number(id) === Number(this.EventoActivo)){
					this.$router.push({ name: 'organizador-eventos' })
				} else {
					if(this.orAc.Permisos.includes('VerEstadisticasEvento')){
						this.$router.push({ name: 'organizador-evento-estadisticas', params: { eventoId: Number(id) } })
					} else {
						if(this.orAc.Permisos.includes('VerTickets')){
							this.$router.push({ name: 'organizador-evento-tickets', params: { eventoId: Number(id) } })
						} else {
							if(this.orAc.Permisos.includes('VerCortesias')){
								this.$router.push({ name: 'organizador-evento-cortesias', params: { eventoId: Number(id) } })
							} else {
								this.$store.dispatch('showError', 'No tienes permisos')
							}
						}
					}
				}
			},
			async getEventos(){
				try {
					let response = await axios.post('/WSOrgEventos', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId : this.user.UsuarioId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 10){
							this.$store.dispatch('showError', 'Necesitas permisos para ver esta sección.')
							this.$router.push({ name: 'home' });
						} else {
							this.SDTEventos = response.data.SDTDashboardEventosCard
							this.CantEventos = response.data.CantEventos
							this.CantTickets = response.data.CantTickets
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al intentar obtener los eventos del organizador.')
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#organizador-eventos-page{
		width: 100%;
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 0px;

		.eventos-top{
			width: 100%;
			@include flex(row, space-between, center);

			.slider-eventos{
				margin-bottom: 20px;
				width: calc(100% - 100px);

				.evento{
					border-radius: 12px;
					background-color: var(--color-white);
					border: 1px solid rgb(221, 221, 221);
					padding: 20px 15px 10px 15px;
					width: 100%;
					height: 100%;
					cursor: pointer;
					transition: all .2s;
					@include flex(row, space-between, center);

					&.eve-selected{
						border-color: #0071e0;

						.evento-left{
							.evento-nombre, .evento-competencia, .evento-tipo{
								color: #0071e0;
							}
						}

						.evento-right{
							.evento-fecha .fecha-dia, .evento-fecha .fecha-mes, .evento-fecha .fecha-nro{
								color: #0071e0;
							}
						}
					}

					&.eve-ing, &.eve-fin{
						border-color: #e1ecf0;
						background-color: transparent;
					}

					.evento-top{
						position: absolute;
						top: 8px;
						right: 20px;
						@include flex(row, flex-end, center);

						.evento-estado{
							border-radius: 4px;
							padding: 2px 3px;
							line-height: 1em;
							color: white;
							font-weight: 300;
							font-size: 11px;
						}

						i{
							margin-right: 5px;
							font-size: 18px;
							// color: var(--color-grey);
						}
					}

					.evento-left{
						width: calc(100% - 40px);
						@include flex(column, center, flex-start);

						.evento-tipo{
							color: var(--color-grey);
							text-transform: uppercase;
							font-size: 10px;
							margin-bottom: 5px;
							letter-spacing: 1px;
							font-weight: 500;
						}

						.evento-competencia{
							color: var(--color-grey);
							text-transform: uppercase;
							font-size: 11px;
							margin-top: 5px;
							letter-spacing: 0px;
							font-weight: 400;
						}

						.evento-row{
							width: 100%;
							padding-right: 10px;
							@include flex(row, flex-start, center);

							.evento-info{
								@include flex(column, center, flex-start);
							}
						}

						.evento-nombre{
							// text-transform: uppercase;
							font-size: 13px;
							letter-spacing: 0.2px;
							font-weight: var(--fw-700);
							font-family: var(--font-sora);
						}

						.evento-instituciones{
							z-index: 10;
							margin-right: 14px;
							@include flex(column, center, center);

							.institucion{
								position: relative;
								width: 38px;
								height: 38px;
								box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.2);
								border-radius: 99%;
								background-color: var(--color-white);
								@include flex(row, center, center);
								@include transition(all .3s ease);

								&:nth-child(1){
									margin-left: 0;
									z-index: 10;
								}

								&:nth-child(2){
									z-index: 6;
									margin-top: -10px;
								}

								img{
									height: 24px;
									width: 24px;
									padding: 0px;
								}

								&:after{
									content: attr(data-tooltip);
									background: var(--color-white);
									border-radius: 8px;
									box-shadow: 5px 8px 20px rgba(0, 0, 0, 0.27);
									font-size: 11px;
									font-weight: 400;
									left: 44px;
									opacity: 0;
									padding: 4px 11px;
									position: absolute;
									text-align: center;
									transition: all .3s ease;
									visibility: hidden;
									width: -webkit-max-content;
									width: max-content;
									z-index: 10;
								}

								&:hover{
									-webkit-transform: scale(1.1);
									transform: scale(1.1);
									z-index: 10;

									&:after{
										opacity: 1;
										visibility: visible;
									}
								}
							}

							&:hover{
								.involucrado{
									margin-left: 0px !important;
								}
							}
						}
					}

					.evento-right{
						width: 40px;
						height: 100%;
						@include flex(column, center, center);

						.evento-fecha{
							@include flex(column, center, center);

							.fecha-nro{
								font-size: 20px;
								color: var(--color-darker);
								font-weight: 700;
								line-height: 1.2em;
								margin-bottom: 2px;
								margin-top: 2px;
							}

							.fecha-dia{
								font-size: 11px;
								color: var(--color-darker);
								font-weight: 400;
								letter-spacing: 1px;
								text-transform: uppercase;
							}

							.fecha-mes{
								font-size: 11px;
								color: var(--color-darker);
								font-weight: 400;
								letter-spacing: 1px;
								text-transform: uppercase;
							}
						}

						.evento-hora{
							padding-top: 10px;
						}
					}
				}
			}

			.slider-arrows{
				width: 100px;
				@include flex(row, center, flex-end);

				.eve-arrow{
					@include flex(row, center, center);
					cursor: pointer;
					transition: all .2s;

					img{
						width: 26px;
						height: auto;
					}

					&.eve-arrow-previous{
						transform: rotate(180deg);
						margin-right: 10px;
					}
				}
			}
		}

		.eventos-content{
			width: 100%;
			@include flex(column, flex-start, flex-start);

			.dashboard-grid{
				margin-top: 20px;
				width: 100%;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				grid-auto-rows: 1fr;
				grid-column-gap: 20px;
				grid-row-gap: 20px;

				.dashboard-card{
					width: 100%;
					@include flex(column, center, center);
					// box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
					border-radius: 12px;
					min-height: 160px;
					background-color: var(--color-white);
					padding: 20px;

					border: 1px solid #222;
					transform: translate(-0.25rem,-0.25rem);
					box-shadow: 0.25rem 0.25rem 0 #222;

					span.card-value{
						font-size: 30px;
						font-family: var(--font-sora);
						line-height: 1.4em;
						font-weight: var(--fw-700);
						text-align: center;

						i{
							font-size: 34px;
						}
					}

					span.card-label{
						font-size: 16px;
						font-family: var(--font-sora);
						line-height: 1.4em;
						font-weight: var(--fw-400);
						text-align: center;
						margin-top: 4px;
					}
				}
			}
		}
	}
</style>